<template>
  <div class="tag-sel">
    <div class="tag-sel__cont">
      <div class="tag-sel__header">
        <div class="tag-sel__title">
          Tag
        </div>
        <fai class="tag-sel__close"
          icon="plus"
          @click="$emit('close')"
        ></fai>
      </div>
      <div class="tag-sel__tags-cont">
        <div class="tag-sel__tag"
          v-for="(tag, index) in tags"
          :key="index"
          @click="selected(tag)">
          <div class="tag-sel__tag-text">{{ tag.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: Array
  },

  methods: {
    selected (tag) {
      this.$emit('selected', tag)
    }
  }
}
</script>

<style lang="scss">
.tag-sel {

  &__cont {
    background: white;
    border: solid 1px;
    border-color: $borderGrey;
    border-radius: 4px;
    min-width: 100px;
  }

  &__header {
    padding: 4px 10px;
    border-bottom: solid 1px;
    border-color: $borderGrey;
    display: flex;
    justify-content: space-between;
  }

  &__title {
    font-size: 0.8em;
  }

  &__close {
    transform: rotate(45deg);
    opacity: 30%;
    cursor: pointer;
  }

  &__tags-cont {
    overflow-y: auto;
    max-height: 180px;
  }

  &__tag {
    font-size: 0.8em;
    padding: 5px 10px;
    cursor: pointer;
  }
}
</style>
